<template>
    <table class="table">
        <tbody>
        <SubscriptionTypeRow
                @show-subscribers-active="showSubscribersActive"
                :subscriptionType="subscriptionType"
                v-for="subscriptionType in subscriptionsTypes"
                v-bind:key="subscriptionType.id"
        ></SubscriptionTypeRow>
        </tbody>
    </table>
</template>

<script>

    import SubscriptionTypeRow from "./SubscriptionTypeRow";

    export default {
        name: "SubscriptionTypeTable",
        components: { SubscriptionTypeRow },
        props: {
            subscriptionsTypes: {
                type: Array,
                required: true
            }
        },
        methods: {
            showSubscribersActive(subscriptionTypeId) {
                this.$emit('show-subscribers-active', subscriptionTypeId)
            }
        }
    }
</script>